"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ILink.js.map